// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ey-z","tooltipWrapper":"fy-z","icon":"gy-z","tooltip":"hy-z","content":"iy-z"};